import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const IdValidation = ({
  idValidated, idPhotoApproved, selfieApproved, rejectionNote, idVerificationStatus
}) => {
  const items = [
    { name: "Government ID", approved: idPhotoApproved },
    { name: "Selfie",  approved: selfieApproved }
  ];

  return (
    <div className="id-validation">
      { idValidated?
      <div className="status text-success">
        <i className="fa fa-check-circle" /> Verified
      </div> :
      <div className="status text-danger">
        <i className="fa fa-exclamation-triangle" /> Verification Failed
      </div> }

      { !idValidated &&
      <div>
        { items.map(item => (
        <div key={item.name} className="item">
          <label>{ item.name }</label>
          { item.approved?
          <div className="item-status text-success">
            <i className="fa fa-check-circle" /> VERIFIED
          </div> :
          <div className="item-status text-danger">
            <i className="fa fa-exclamation-triangle" /> FAILED
          </div> }
        </div>
        )) }

        { !!rejectionNote &&
        <div className="text-danger rejection-note">
          <strong>Note from crowdspring:</strong> { rejectionNote }
        </div> }

        { ['draft', 'waiting_for_creative'].includes(idVerificationStatus) &&
        <Link to="/register/continue/" className="btn btn-tertiary btn-block">Fix problems</Link> }
      </div> }
    </div>
  );
}

IdValidation.propTypes = {
  idValidated: PropTypes.bool.isRequired,
  idPhotoApproved: PropTypes.bool,
  selfieApproved: PropTypes.bool,
  rejectionNote: PropTypes.string,
  idVerificationStatus: PropTypes.string,
}

export default IdValidation;



// WEBPACK FOOTER //
// ./account/components/id_verification/id_validation.jsx